class GeoObjectStore {
  objects = []
  clickedObjects = []

  add (clickedObject, objects) {
    this.objects = [...this.objects, ...objects]
    this.clickedObjects.push(clickedObject)
  }

  getObjects () {
    let uniqueObjects = []
    let uniqueIds = []
    for (const object of this.objects) {
      if (!uniqueIds.includes(object.id)) {
        uniqueIds.push(object.id)
        uniqueObjects.push(object)
      }
    }
    return uniqueObjects
  }

  getClickedObjects () {
    return this.clickedObjects
  }

  reset () {
    this.objects = []
    this.clickedObjects = []
  }
}

export default new GeoObjectStore()
